import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { withAuth } from '@cdk-prod/fortellis-auth-context';
import { withEntityContext } from '@cdk-prod/fortellis-entity-context';
import { SessionRefreshDialog } from '@fortellis/session-refresh-dialog';

function AuthSessionRefreshDialog({ auth }) {
  return auth.isAuthenticated ? (
    <SessionRefreshDialog
      onSignOut={auth.logout}
      sessionExpiryTime={auth.expiresAt}
      Timeout={10}
      continueWorking={auth.continueWorking}
    />
  ) : null;
}

AuthSessionRefreshDialog.propTypes = {
  auth: PropTypes.object.isRequired
};

export default withRouter(
  withAuth(withEntityContext(AuthSessionRefreshDialog))
);
